export default __webpack_public_path__ + "static/illustration-content-title.url-e174ae6761852ab8a525b0c1ca0e57f0.svg";